module.exports = __webpack_public_path__ + "static/media/b2_p3_melody.101cd5d1.mp3";